import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=94bddf52&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=ts"
export * from "./OrderItem.vue?vue&type=script&lang=ts"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=94bddf52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bddf52",
  null
  
)

export default component.exports